
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/on-som",
      function () {
        return require("private-next-pages/on-som/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/on-som"])
      });
    }
  